"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoisesUpload = void 0;
const axios_1 = __importDefault(require("axios"));
const http_client_1 = require("../lib/http-client");
class MoisesUpload {
    constructor(config, session) {
        this.config = config;
        this.session = session;
    }
    async localFile({ file, onUploadProgress, setCancelSource }) {
        const CancelToken = axios_1.default.CancelToken;
        const source = CancelToken.source();
        if (setCancelSource)
            setCancelSource(source);
        let result;
        try {
            const { data: upload } = await http_client_1.httpClient({
                userToken: this.session.token,
                baseUrl: this.config.apiEndpoint,
                headers: this.config.headers,
            }).get('/v3/upload', {
                cancelToken: source.token,
            });
            await axios_1.default({
                url: upload.signedUrl,
                method: 'PUT',
                headers: { 'Content-Type': file.type },
                data: file,
                cancelToken: source.token,
                onUploadProgress,
            });
            if (setCancelSource)
                setCancelSource(null);
            result = {
                tempLocation: upload.tempFileLocation,
                provider: 'filesystem',
                input: file.name,
                name: file.name.replace(/\.[^/.]+$/, ''),
            };
        }
        catch (error) {
            if (axios_1.default.isCancel(error)) {
                // tslint:disable-next-line:no-console
                console.log(`Request canceled: ${error.message}`);
            }
            else {
                // tslint:disable-next-line:no-console
                console.error(error);
                throw error;
            }
        }
        return result;
    }
    async externalUrl({ url, urlTitle, onUploadProgress, setCancelSource }) {
        var _a;
        const CancelToken = axios_1.default.CancelToken;
        const source = CancelToken.source();
        if (setCancelSource)
            setCancelSource(source);
        let result;
        try {
            const { data } = await http_client_1.httpClient({
                userToken: this.session.token,
                baseUrl: this.config.urlDownloadEndpoint,
                headers: this.config.headers,
            }).post('/v1', {
                url,
                userToken: this.session.token,
            }, {
                cancelToken: source.token,
            });
            if (setCancelSource)
                setCancelSource(null);
            result = {
                duration: ((_a = data.tmpFile) === null || _a === void 0 ? void 0 : _a.duration) || null,
                tempLocation: data.tmpFile.name,
                provider: 'url',
                input: data.tmpFile.originalUrl,
                name: urlTitle || data.tmpFile.originalName || url,
            };
        }
        catch (error) {
            if (axios_1.default.isCancel(error)) {
                // tslint:disable-next-line:no-console
                console.log(`Request canceled: ${error.message}`);
            }
            else {
                throw error;
            }
        }
        return result;
    }
}
exports.MoisesUpload = MoisesUpload;
